<template>
  <div class="report-selector">
    <div class="name text-truncate" @click="toggleListVisible" :title="selected.name">
      <span v-if="selected.id">{{ selected.name }}</span>
      <span v-else>Selecciona un reporte</span>
      <i class="fa fa-caret-down"></i>
    </div>

    <div class="report-list" v-if="selectionListVisible">
      <div class="items">
        <div class="item text-truncate" v-for="item in reports" :key="item.id" @click="select(item)">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { DashboardReport } from '@/types/Dashboard'

@Component
export default class ReportSelector extends Vue {
  reports: DashboardReport[] = [
    { id: 'cp', name: 'Capacidad y productividad' },
    { id: 'cpd', name: 'Capacidad y productividad detallado' },
    { id: 'eg', name: 'Estatus de gestión' }
  ]

  selected = new DashboardReport()
  selectionListVisible = false

  @Prop({ required: false, default: '' })
  selectedId: number

  @Watch('selectedId')
  watchSelectedId (value: string) {
    if (value && value !== this.selected.id) {
      let found = this.reports.find(it => it.id === value)
      if (found) {
        this.selected = found
      }
    }
  }

  toggleListVisible () {
    this.selectionListVisible = !this.selectionListVisible
  }

  select (report: DashboardReport) {
    this.selected = report
    this.$emit('select', report)
    this.selectionListVisible = false
  }
}
</script>

<style lang="scss" scoped>
.report-selector {
  position: relative;
  height: 45px;
  box-shadow: 0 0 3px #bbbbbb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 200ms ease;

  &:hover {
    box-shadow: 0 0 6px #bbbbbb;
  }

  .name {
    position: relative;
    padding: 11px 25px 11px 11px;

    i {
      position: absolute;
      top: 14px;
      right: 8px;
    }
  }

  .report-list {
    position: absolute;
    z-index: 9;
    top: 57px;
    bottom: 0;
    left: 0;
    right: 0;
    height: 275px;
    box-shadow: 0 2px 7px #b1b1b1;
    border-radius: 4px;
    background: #fff;
    background: linear-gradient(0deg, #fff 0%, #f3f3f3 100%);

    .items {
      height: 100%;
      overflow-y: auto;
      border-radius: 4px;
      margin-bottom: 10px;

      .item {
        padding: 10px 15px;
        font-size: 0.85rem;
        cursor: pointer;
        i {
          margin-right: 8px;
          font-size: 1rem;
          color: #a3a3a3;
        }
        &:hover {
          background-color: var(--element-hover-bg-color);
        }
        &.title {
          color: #a3a3a3;
        }
      }
    }
  }
}
</style>
